import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";
import { SpeedKind, MeasureHighKind } from '../../../../Constant';


export type KIND_NO_NAME_SET = {
  SPEED: number;
  NAME_NO: number;
  MES_NAME: string;
  FFT_INVALID: number;
}

export type NAME_ITEM_SET = {
  ITM_NAME_NO: number;
  EST: number;
  ITM_NAME: string;
}

export type LOG_INT_SET = {
  SPEED: number;
  LOG_INT: number;
  DSP_STR: string;
}

export type DATA_UNIT = {
  NO: number;
  UNIT_STR: string;
}


//計測設定Type
export type PLCcollectSettingType = {
  /// 収集設定行データ
  //ColRow :COL_SET ;
  /// ユニット情報
  //PlcUnitSetRow :PLC_UNIT_SET ;
  /// 機器設定行データ
  //NameDevSetRow :NAME_DEV_SET ;PLCcollectSettingType
  /// PLCNo
  PLCNo: string;
  /// 実行フラグ
  IsExecute: boolean;
  /// ユニット型式名
  UnitName: string;
  /// AIカードNo
  AICardNo: string;
  /// チャンネルNo
  ChannelNo: string;
  /// 計測種別No colSet.KIND_NO
  MeasureKindNo: string;
  /// 計測種別名
  MeasureKindName: string;
  /// AIユニット登録番号
  AIUnit: number;
  /// 収集時間
  CollectionTime: string;
  /// 機器INDEX
  MachineIndex: string;
  /// 機器No
  MachineNo: string;
  /// 機器名称
  MachineName: string;
  /// 項目名称No
  ItemNameNo: number;
  /// 名称No.
  NameNo: number;
  /// 項目名称
  ItemName: string;
  /// ロギング周期
  LoggingPeriod: string;
  /// ロギング周期(分）
  LoggingPeriodMinute: number;
  /// ロギング周期開始時間
  LoggingStartTime: Date;
  /// 上書きフラグ
  IsOverwrite: boolean;
  /// デジタル値下限値
  DigitalValueLower: string;
  /// デジタル値上限値
  DigitalValueUpper: string;
  /// 工学値下限値
  EngineeringValueLower: string;
  /// 工学値上限値
  EngineeringValueUpper: string;
  /// 乗率　設定値
  Mul: number;
  /// 乗率
  MultiplicationFactor: number;
  /// 単位記号
  UnitSymbol: string;
  /// PLCデータ格納ZR点数(設定画面で計算してセット)
  ZRChCount: number;
  /// オフセット電圧
  OffsetVoltage: string;
  /// 判定ボタン
  JudgmentButtonEnable: boolean;
  /// グラフ表示ボタン
  GraphButtonEnable: boolean;
  /// メモ
  Note: string;
  /// モータ起動状態検出フラグ モータ起動状態検出信号の際1とする。(線電流か零相電流)
  StartDet: number;
  /// ユニット種別 1:低速 2:高速 3:EMC-B 4:計算タグ plcUnitSet.SPEED
  Speed: number;
  DataUnitStr: string;

  /// アベレージング処理
  AvgPrc: number;
  /// エンベロープ処理
  EnvSav: boolean;
  /// 回転周波数算出センサ
  RotClc: boolean;
  ///ローパスフィルタフラグ
  LowPassFlg:boolean;
  //カットオフ周波数
  CutOffFreq:number;
  //フィルタ次数
  FilterOrder:number;

  /// リアルタイムトレンド上限値
  RealtimeTrendValueUpper: string;
  /// リアルタイムトレンド上上限値
  RealtimeTrendValueUpperUpper: string;
  /**
   * 速度・変位判定マスク
   */
  DispMaskOn: number;

  // 定格回転数
  RatedSpeed: number;

  ValID: number;

  //変更フラグ
  isEdit: boolean;
  //IoTLocal_Sav更新フラグ
  //AWSへ通知が必要なフラグ
  isIotEdit: boolean;
  //連番
  id: number;
};

export type PLCcollectSettingUpdateType = {
  /// PLCNo
  PLCNo: string;
  /// AIカードNo
  AICardNo: string;
  /// チャンネルNo
  ChannelNo: string;
  /// 有効フラグ
  ValID: number;
  /// 実行フラグ
  IsExecute: boolean;
  // /// セット番号
  // SetNo: number;
  /// 計測種別No
  MeasureKindNo: string;
  /// 機器INDEX
  MachineIndex: string;
  /// 項目名称No
  ItemNameNo: number;
  /// ロギング周期(分）
  LoggingPeriodMinute: number;
  /// ロギング周期開始時間
  LoggingStartTime: Date;
  /// 上書きフラグ
  IsOverwrite: boolean;
  /// デジタル値下限値
  DigitalValueLower: string;
  /// デジタル値上限値
  DigitalValueUpper: string;
  /// 工学値下限値
  EngineeringValueLower: string;
  /// 工学値上限値
  EngineeringValueUpper: string;
  /// 乗率　設定値
  Mul: number;
  /// 単位記号
  UnitSymbol: string;
  /// PLCデータ格納ZR点数(設定画面で計算してセット)
  ZRChCount: number;
  /// メモ
  Note: string;
  /// モータ起動状態検出フラグ モータ起動状態検出信号の際1とする。(線電流か零相電流)
  StartDet: number;
  /// アベレージング処理
  AvgPrc: number;
  /// エンベロープ処理
  EnvSav: boolean;
  /// 回転周波数算出センサ
  RotClc: boolean;
  ///ローパスフィルタフラグ
  LowPassFlg:boolean;
  //カットオフ周波数
  CutOffFreq:number;
  //フィルタ次数
  FilterOrder:number;

  /// リアルタイムトレンド上限値
  RealtimeTrendValueUpper: string;
  /// リアルタイムトレンド上上限値
  RealtimeTrendValueUpperUpper: string;
};

export const GetKindNoNameSetType = (): Promise<KIND_NO_NAME_SET[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/KindNoNameSet";
    fetch(url)
      .then((res) => res.json())
      .then((result: KIND_NO_NAME_SET[]) => {
        console.debug(result);
        if (KindNoNameSetTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const KindNoNameSetTypeValidate = (data: KIND_NO_NAME_SET[]) => {
  if (data == undefined) return false;
  return true;
};

// NAME_ITEM_SET
export const GetNameItemSetType = (): Promise<NAME_ITEM_SET[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/NameItemSet";
    fetch(url)
      .then((res) => res.json())
      .then((result: NAME_ITEM_SET[]) => {
        console.debug(result);
        if (NameItemSetTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const NameItemSetTypeValidate = (data: NAME_ITEM_SET[]) => {
  if (data == undefined) return false;
  return true;
};

export const SetNameItemSetType = (list: NAME_ITEM_SET[]): Promise<void> => {
  return new Promise((resolve, reject) => {
    fetch('api/NameItemSet', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(list),
    })
      .then(res => resolve())
      .catch(reason => reject(reason));
  });
}

export const GetLogIntSetType = (): Promise<LOG_INT_SET[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/LogIntSet";
    fetch(url)
      .then((res) => res.json())
      .then((result: LOG_INT_SET[]) => {
        console.debug(result);
        if (LogIntSetTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const LogIntSetTypeValidate = (data: LOG_INT_SET[]) => {
  if (data == undefined) return false;
  return true;
};


//乗率
export type MulDataType = {
  code: number;
  value: string;
}

export const GetmulItems = (): Promise<MulDataType[]> => {
  return new Promise((resolve, reject) => {
    var ret: MulDataType[] = [
      { code: -5, value: '0.00001' },
      { code: -4, value: '0.0001' },
      { code: -3, value: '0.001' },
      { code: -2, value: '0.01' },
      { code: -1, value: '0.1' },
      { code: 0, value: '1' },
      { code: 1, value: '10' },
      { code: 2, value: '100' },
    ];
    resolve(ret);
  });
}



export const GetDataUnitType = (): Promise<DATA_UNIT[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/DataUnit";
    fetch(url)
      .then((res) => res.json())
      .then((result: DATA_UNIT[]) => {
        console.debug(result);
        if (DataUnitTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const DataUnitTypeValidate = (data: DATA_UNIT[]) => {
  if (data == undefined) return false;
  return true;
};


export const GetPLCcollectSettingType = (plcNo: number): Promise<PLCcollectSettingType[]> => {
  return new Promise((resolve, reject) => {
    const url = 'api/PLCcollectSettingModels'.concat(plcNo == 0 ? '' : `/${plcNo}`);
    fetch(url)
      .then((res) => res.json())
      .then((result: PLCcollectSettingType[]) => {
        if (PLCcollectSettingTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const PLCcollectSettingTypeValidate = (data: PLCcollectSettingType[]) => {
  if (data == undefined) return false;
  return true;
};

export const SetPLCcollectSetting = (settings: PLCcollectSettingType[]): Promise<number> => {
  const saveSettings = settings.map<PLCcollectSettingUpdateType>((setting) => {
    return {
      PLCNo: setting.PLCNo,
      AICardNo: setting.AICardNo,
      ChannelNo: setting.ChannelNo,
      ValID: 1,
      IsExecute: setting.IsExecute,
      MeasureKindNo: setting.MeasureKindNo,
      MachineIndex: setting.MachineIndex,
      ItemNameNo: setting.ItemNameNo,
      LoggingPeriodMinute: setting.LoggingPeriodMinute,
      LoggingStartTime: setting.LoggingStartTime,
      IsOverwrite: setting.IsOverwrite,
      DigitalValueLower: setting.DigitalValueLower,
      DigitalValueUpper: setting.DigitalValueUpper,
      EngineeringValueLower: setting.EngineeringValueLower,
      EngineeringValueUpper: setting.EngineeringValueUpper,
      Mul: setting.Mul,
      UnitSymbol: setting.UnitSymbol,
      ZRChCount: setting.ZRChCount,
      Note: setting.Note,
      StartDet: setting.StartDet > 0 ? 1 : 0,
      AvgPrc: setting.AvgPrc,
      EnvSav: setting.EnvSav,
      RotClc: setting.RotClc,
      LowPassFlg:setting.LowPassFlg,
      CutOffFreq:setting.CutOffFreq,
      FilterOrder:setting.FilterOrder,
      RealtimeTrendValueUpper: setting.RealtimeTrendValueUpper,
      RealtimeTrendValueUpperUpper: setting.RealtimeTrendValueUpperUpper,
      AIUnit: 0,
      DispMaskOn: setting.DispMaskOn,
      IsIotEdit: setting.isIotEdit,
    };
  });
  return new Promise((resolve, reject) => {
    const url = "api/PLCcollectSettingModels";
    fetch(url, {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(saveSettings),
    })
      .then((res) => res.json())
      .then((res: ResponceDataType) => {
        if (res.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          resolve(res.ErrorCode);
        }
        else {
          console.error(res.ErrorMessage);
          resolve(res.ErrorCode);
        }
      })
      .catch(reason => {
        reject(reason)
      });
  });
}

/**
 * 判定値設定が行えるかチェック
 * @param settings
 * @returns
 */
export const IsJudgeSetting = (settings: PLCcollectSettingType): boolean => {

  if (settings.AIUnit === 1) {
    return true;
  }
  if (settings.AIUnit === 8) {
    return true;
  }
  //コナンエア
  if (settings.AIUnit === 12) {
    return true;
  }

  return false;
}

/**
 * コナンエアの計測種別表示に表示する文字列を返す
 */
export const GetConanMeasureName = (kindNoNameList: KIND_NO_NAME_SET[]): string => {
  let name = kindNoNameList.find(
    (item) => item.SPEED === SpeedKind.SPEED_KIND_HIGHT && item.NAME_NO === MeasureHighKind.VIBRATION
  )?.MES_NAME;
  return name ?? "";
}

/**
 * IoTBoxデータの項目名称が零相、逆相対象のチャンネルかどうかを返す
 * @param settings
 * @returns
 */
export const IsIoTZeroGyakuSetting = (settings: PLCcollectSettingType): boolean => {

  //零相、逆相
  var array = ['39', '40'];
  if (array.includes(settings.ChannelNo)) {
    return true;
  }
  else {
    return false;
  }
}

/**
 * PLC版で計算タグデータかを返す
 * @param settings
 * @returns
 */
export const IsPLCCalcSetting = (settings: PLCcollectSettingType): boolean => {

  //AUユニットセットのENT_NOが８の項目は計算
  if (settings.AIUnit === 8) {
    return true;
  }
  else {
    return false;
  }
}
